import { CampaignType, Scope } from '../shared';

const campaignTypes = [CampaignType.Default, CampaignType.Shopping, CampaignType.Audience,
  CampaignType.DynamicSearchAds, CampaignType.Smart, CampaignType.Hotel];

export const digitalMaturityScore = {
  id: 'digital-maturity-score',
  name: _TL_('Digital Maturity Score'),
  campaignTypes,
  scope: [Scope.Account],
  checkPermission: permissions => permissions.dynamic.DigitalMaturityScore,
  children: [
    {
      id: 'digital-maturity-score',
      name: _TL_('Digital Maturity Score'),
      route: 'digitalmaturityscore',
      scope: [Scope.Account],
      checkPermission: permissions => permissions.dynamic.DigitalMaturityScore,
    },
  ],
};
